<template lang="pug">
  .pdp-banner.container
    SiteMessageBannerCarousel(:topics="productTopics")

</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: "PdpBanner",

    components: {
      SiteMessageBannerCarousel: () => import(/* webpackChunkName: 'SiteMessageBannerCarousel' */'@components/SiteMessageBannerCarousel'),
    },

    computed: {
      ...mapState('pdp', ['product']),

      productTopics() {
        var topics = '';
        
        if (this.product) {
          topics = this.product.product_type + ',' + this.product.code;
        }

        return topics;
      }
    }
  };
</script>

<style scoped lang="stylus">
    
</style>
